import React from 'react'
import { useTranslation } from 'react-i18next';
import { SLABreachedStatuses } from 'src/resources/enum'
interface SLABreachedProps {
    sLABreached?: string;
  }
  
const SLATemplate : React.FC<SLABreachedProps> = ({ sLABreached }) => {
    const { t } = useTranslation(["common", "registration"]);
    return (
        <div>
          {sLABreached === SLABreachedStatuses.Exceeded ? (
            <div className="d-flex gap-1 align-items-center">
              <span className="oval red-oval">{t("exceeded")}</span>
            </div>
          ) : (
            <div className="d-flex gap-1 align-items-center">
              <span className="oval blue-oval">{t("onTrack")}</span>
            </div>
          )}
        </div>
      
  )
}

export default SLATemplate